import {
    AuthenticationState,
    EventName,
    addEventListener,
    getAuthenticationState,
} from '@soluto-private/mx-app-authentication';
import { Key, listen, storageEvents } from '@soluto-private/mx-context';

import { getExpertChatConfiguration } from './utils';
import initializeSDK from './api/initialize';
import updateLanguageFromContext from './localization/updateLanguageFromContext';

export * from './api';
export * from './types';

const isLoggedIn = () =>
    getAuthenticationState() === AuthenticationState.LoggedIn;

const initSDKWithAppKey = async () => {
    if (isLoggedIn()) {
        const { enabled, key } = await getExpertChatConfiguration();
        if (enabled && key) {
            await initializeSDK(key);
        }
    }
};

const onLoad = async () => {
    await initSDKWithAppKey();

    listen(storageEvents.keyUpdated(Key.Client), () => initSDKWithAppKey);
    listen(
        storageEvents.keyUpdated(Key.Language),
        () => updateLanguageFromContext
    );
    addEventListener(EventName.LoggedIn, () => initSDKWithAppKey);
};

void (async () => await onLoad())();
